import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { querySaga } from '../../../utils/reduxHelper';

function* resetPrioritySaga() {
    yield put(appActions.PRIORITY_RESET_SUCCESS());
}

function* resetTimeZoneSaga() {
    yield put(appActions.PRIORITY_RESET_SUCCESS());
}

function* resetTaskTypeSaga() {
    yield put(appActions.TASKTYPE_RESET_SUCCESS());
}

function* resetRepeatSaga() {
    yield put(appActions.REPEAT_RESET_SUCCESS());
}

function* resetProgressSaga() {
    yield put(appActions.PROGRESS_RESET_SUCCESS());
}

function* resetStoreSaga() {
    yield put(appActions.STORE_RESET_SUCCESS());
}

function* resetSiteGroupListSaga() {
    yield put(appActions.SITEGROUPLIST_RESET_SUCCESS());
}

function* resetUserListSaga() {
    yield put(appActions.USERLIST_RESET_SUCCESS());
}

function* resetReminderSaga() {
    yield put(appActions.REMINDER_RESET_SUCCESS());
}

function* resetRoleListSaga() {
    yield put(appActions.ROLESLIST_RESET_SUCCESS());
}

function* watchPriorityGetAllRequest() {
    yield takeLatest(
        appActions.PRIORITY_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.PRIORITY_GET_ALL_SUCCESS,
                appActions.PRIORITY_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchTimeZoneGetAllRequest() {
    yield takeLatest(
        appActions.TIMEZONE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.TIMEZONE_GET_ALL_SUCCESS,
                appActions.TIMEZONE_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchRolesListGetAllRequest() {
    yield takeLatest(
        appActions.ROLESLIST_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.ROLESLIST_GET_ALL_SUCCESS,
                appActions.ROLESLIST_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchTaskTypeGetAllRequest() {
    yield takeLatest(
        appActions.TASKTYPE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.TASKTYPE_GET_ALL_SUCCESS,
                appActions.TASKTYPE_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchRepeatGetAllRequest() {
    yield takeLatest(
        appActions.REPEAT_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.REPEAT_GET_ALL_SUCCESS,
                appActions.REPEAT_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchProgressGetAllRequest() {
    yield takeLatest(
        appActions.PROGRESS_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.PROGRESS_GET_ALL_SUCCESS,
                appActions.PROGRESS_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchStoreGetAllRequest() {
    yield takeLatest(
        appActions.STORE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/site',
                appActions.STORE_GET_ALL_SUCCESS,
                appActions.STORE_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchSiteGroupListGetAllRequest() {
    yield takeLatest(
        appActions.SITEGROUPLIST_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/sitegroup',
                appActions.SITEGROUPLIST_GET_ALL_SUCCESS,
                appActions.SITEGROUPLIST_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchUserListGetAllRequest() {
    yield takeLatest(
        appActions.USERLIST_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/user',
                appActions.USERLIST_GET_ALL_SUCCESS,
                appActions.USERLIST_GET_ALL_FAILURE,
            );
        },
    );
}

function* watchReminderGetAllRequest() {
    yield takeLatest(
        appActions.REMINDER_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/propconfig',
                appActions.REMINDER_GET_ALL_SUCCESS,
                appActions.REMINDER_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* commonWatcher() {
    yield* watchPriorityGetAllRequest();
    yield takeLatest(appActions.PRIORITY_RESET_REQUEST.type, resetPrioritySaga);
    yield* watchTimeZoneGetAllRequest();
    yield takeLatest(appActions.TIMEZONE_RESET_REQUEST.type, resetTimeZoneSaga);
    yield* watchTaskTypeGetAllRequest();
    yield takeLatest(appActions.TASKTYPE_RESET_REQUEST.type, resetTaskTypeSaga);
    yield* watchRepeatGetAllRequest();
    yield takeLatest(appActions.REPEAT_RESET_REQUEST.type, resetRepeatSaga);
    yield* watchProgressGetAllRequest();
    yield takeLatest(appActions.PROGRESS_RESET_REQUEST.type, resetProgressSaga);
    yield* watchStoreGetAllRequest();
    yield takeLatest(appActions.STORE_RESET_REQUEST.type, resetStoreSaga);
    yield* watchSiteGroupListGetAllRequest();
    yield takeLatest(appActions.SITEGROUPLIST_RESET_REQUEST.type, resetSiteGroupListSaga);
    yield* watchUserListGetAllRequest();
    yield takeLatest(appActions.USERLIST_RESET_REQUEST.type, resetUserListSaga);
    yield* watchReminderGetAllRequest();
    yield takeLatest(appActions.REMINDER_RESET_REQUEST.type, resetReminderSaga);
    yield* watchRolesListGetAllRequest();
    yield takeLatest(appActions.ROLESLIST_RESET_REQUEST.type, resetRoleListSaga);
    // Add other watchers here
}
